import { Alert as MuiAlert } from '@mui/material';
import PropTypes from 'prop-types';
import { useEffect } from 'react';

Alert.propTypes = {
  open: PropTypes.bool.isRequired,
  severity: PropTypes.oneOf(['error', 'warning', 'info', 'success']),
  message: PropTypes.node,
  onClose: PropTypes.func,
  autoHideDuration: PropTypes.number,
  sx: PropTypes.object,
};

export default function Alert({ open, severity = 'info', message, onClose, autoHideDuration = 2000, sx }) {
  useEffect(() => {
    if (!open || !autoHideDuration || autoHideDuration <= 0) return undefined;

    const timer = setTimeout(() => {
      onClose?.();
    }, autoHideDuration);

    return () => clearTimeout(timer);
  }, [open, autoHideDuration, onClose]);

  if (!open) return null;

  return (
    <MuiAlert severity={severity} onClose={onClose} sx={sx}>
      {message}
    </MuiAlert>
  );
}
